import React from "react";
import { Drawer, Input, Button, message } from "antd";
import { Share2 } from "lucide-react";
import { getReferralLink } from "../../utils/referralHelpers";

const AmbassadorReferralLinksDrawer = ({ open, onClose, accountId }) => {
  const referralTypes = [
    { label: "Marketplace Customer Link", type: "marketplace" },
    { label: "Business Partner Link", type: "business" },
    { label: "Ambassador Link", type: "ambassador" },
    { label: "Wise9ja Campaign Link", type: "wise9ja" },
  ];

  return (
    <Drawer
      placement="bottom"
      open={open}
      onClose={onClose}
      height="auto"
      className="rounded-t-3xl"
      title={
        <div className="flex items-center gap-2">
          <Share2 className="w-5 h-5 text-emerald-600" />
          <span className="font-gilroyBold text-xl text-gray-900">
            Your Referral Links
          </span>
        </div>
      }
    >
      <div className="p-2 space-y-4 pb-6">
        <p className="text-gray-500 text-base">
          Select and copy any referral link tailored for your promotion:
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {referralTypes.map((item) => {
            const link = getReferralLink(accountId || "ACCOUNT_ID", item.type);
            return (
              <div
                key={item.type}
                className="p-4 bg-gray-50 border border-gray-200/80 rounded-2xl space-y-2"
              >
                <p className="font-gilroyBold text-gray-900 text-base m-0">
                  {item.label}
                </p>
                <div className="flex gap-2">
                  <Input
                    value={link}
                    readOnly
                    className="bg-white text-xs font-mono rounded-xl border-gray-200"
                  />
                  <Button
                    type="primary"
                    className="bg-emerald-600 hover:bg-emerald-500 text-white font-gilroyBold text-xs rounded-xl cursor-pointer border-0"
                    onClick={() => {
                      navigator.clipboard.writeText(link);
                      message.success(`${item.label} copied!`);
                    }}
                  >
                    Copy
                  </Button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Drawer>
  );
};

export default AmbassadorReferralLinksDrawer;
